import {Stack, TextField} from '@mui/material';
import {forwardRef, useImperativeHandle} from 'react';
import {Controller, useForm, UseFormReturn} from 'react-hook-form';
import {Filter} from '../../types';
import {ContractsTableFiltersList} from './contracts-table-filters-list';

interface FormValues {
  name: string;
}

interface Props {
  filters: Filter[];
  defaultValues: FormValues;
}

export interface ContractsTableFiltersModalFormRef {
  form: UseFormReturn<FormValues>;
}

export const ContractsTableFiltersModalForm = forwardRef<ContractsTableFiltersModalFormRef, Props>((props, ref) => {
  const {filters, defaultValues} = props;

  const formApi = useForm<FormValues>({mode: 'onChange', defaultValues});

  useImperativeHandle(ref, () => ({form: formApi}));

  return (
    <Stack spacing={2}>
      <Controller
        control={formApi.control}
        name="name"
        rules={{required: 'Введите название фильтра'}}
        render={({field, fieldState: {error}}) => (
          <TextField label="Имя набора фильтров" fullWidth {...field} error={!!error} helperText={error?.message} />
        )}
      />
      <ContractsTableFiltersList filters={filters} />
    </Stack>
  );
});

ContractsTableFiltersModalForm.displayName = 'ContractsTableFiltersModalForm';
